<template>
  <v-app>
    <v-main>
      <v-tabs
        v-model="selectedTab"
        centered
        slider-color="green"
        class="sticky-tabs"
      >
        <v-tab :to="{ name: 'home' }" key="tab1" @click="resetHomeView"
          >Home</v-tab
        >
        <v-tab :to="{ name: 'project-management' }" key="tab2"
          >Projekt-Verwaltung</v-tab
        >
        <v-tab :to="{ name: 'import' }" key="tab3">CleverRoute-Import</v-tab>
        <v-tab :to="{ name: 'map-editor' }" key="tab4">Karten-Editor</v-tab>
        <v-tab :to="{ name: 'results' }" key="tab5">Ergebnistabellen</v-tab>
        <v-tab key="tab6">
          <UserInvitationDialog></UserInvitationDialog>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="selection-info px-4">
          <v-chip
            v-if="selectedProjectName"
            color="primary"
            size="small"
            class="mr-2"
          >
            Projekt: {{ selectedProjectName }}
          </v-chip>
          <v-chip
            v-if="selectedCompanyName"
            color="secondary"
            size="small"
            class="mr-2"
          >
            Firma: {{ selectedCompanyName }}
          </v-chip>
          <v-chip
            v-if="selectedOfficeName"
            color="info"
            size="small"
            class="mr-2"
          >
            Büro: {{ selectedOfficeName }}
          </v-chip>
        </div>
        <v-tab key="tab7">
          <button @click="logout()">({{ username }}) abmelden</button>
        </v-tab>
      </v-tabs>
      <div class="page-content">
        <router-view :setResetHomeFunction="setResetHomeFunction"></router-view>
      </div>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

import { useAuthStore } from "../store/authStore";
import UserInvitationDialog from "./UserInvitationDialog.vue";
import { useOfficeStore } from "../store/officeStore";

export default defineComponent({
  components: {
    UserInvitationDialog,
  },
  setup() {
    const authStore = useAuthStore();
    const router = useRouter();
    const officeStore = useOfficeStore();
    const resetHomeFunction = ref(null);

    const setResetHomeFunction = (fn) => {
      resetHomeFunction.value = fn;
    };

    return {
      authStore,
      router,
      officeStore,
      resetHomeFunction,
      setResetHomeFunction,
    };
  },
  data() {
    return {
      selectedTab: undefined as string | undefined,
      dialog: false,
    };
  },
  mounted() {
    this.items = [
      { title: "User einladen", func: () => (this.dialog = true) },
      { title: "Abmeldung", func: () => this.logout() },
      //{ title: "Anmeldung", func: () => this.login() },
    ];
  },
  computed: {
    username() {
      return this.authStore?.user?.username || "";
    },
    selectedProjectId() {
      const id = this.officeStore.getSelectedProject?.id || 0;
      console.log("UserView - selectedProjectId:", id);
      return id;
    },
    selectedCompanyId() {
      const id = this.officeStore.getSelectedCompany?.id || 0;
      console.log("UserView - selectedCompanyId:", id);
      return id;
    },
    selectedOfficeId() {
      const id = this.officeStore.getSelectedOffice?.office_id || 0;
      console.log("UserView - selectedOfficeId:", id);
      return id;
    },
    selectedProjectName() {
      return this.officeStore.getSelectedProject?.name || "";
    },
    selectedCompanyName() {
      return this.officeStore.getSelectedCompany?.name || "";
    },
    selectedOfficeName() {
      return this.officeStore.getSelectedOffice?.office_name || "";
    },
  },
  methods: {
    showDialogValChanged(val) {
      console.log("showDialogValChanged=", val);
      this.dialog = val;
    },
    async logout() {
      const authStore = useAuthStore();
      const keycloakObj = authStore.getKeycloakObj;
      console.log("authStore.clearUserData()");

      authStore.clearUserData();
      keycloakObj
        .logout()
        .then((val) => {
          console.log("logged out-val=", val);
        })
        .catch((err) => console.log("error when logging out: ", err));
    },
    myM() {
      this.selectedTab = "df";
    },
    resetHomeView() {
      // Call the reset function if it's available
      if (this.resetHomeFunction) {
        this.resetHomeFunction();
      }
    },
  },
});
</script>

<style scoped>
.sticky-tabs {
  position: sticky;
  top: 0;
  z-index: 1; /* optional: to ensure the tabs stay on top of other content */
  background-color: white;
}

.page-content {
  margin-top: 20px;
}

.selection-info {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
